import I18n from 'I18n';
import { Map as ImmutableMap } from 'immutable';
import { useContext, useEffect, useState } from 'react';
import { fetchDisaggregatedGoalsForReport, fetchGoalsForReport } from 'reporting-data/apis/goals';
import { DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES } from 'reporting-data/constants/objectCoordinates';
import { IN } from 'reporting-data/constants/operators';
import { getDataType, getReportMetricProperties } from 'reporting-data/report/reportGetters';
import { HS_OBJECT_ID } from 'reporting-snowflake/funnel/constants/fields';
// @ts-expect-error ts-migrate(7016)
import { makeDateRangeByType } from 'reporting-ui-components/components/shared/lib/DateRangeHelpers';
import { REPORT_OBJECT_ID_COUNT_PROPERTY } from './constants';
import { getUniqueGoalForReportId, getValueFromCustomFilters } from './utils';
import { ADDITIONAL_OBJECT_TYPES_IN_SRV } from '../../../constants/gates';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
export const useFetchGoalsForGoalsEditor = (report, deferred = false) => {
  const [goals, setGoals] = useState(ImmutableMap());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const {
    gates
  } = useContext(UserInfoContext);
  const ungatedForAdditionalObjectTypes = gates.includes(ADDITIONAL_OBJECT_TYPES_IN_SRV);
  useEffect(() => {
    if (deferred) {
      return;
    }
    setLoading(true);
    const dataType = getDataType(report);
    const objectTypeId = DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES.get(dataType) || dataType;
    const frequency = report.getIn(['config', 'frequency']);
    const dateRangeFilter = report.getIn(['config', 'filters', 'dateRange', 'value']);
    const dateRangeReport = makeDateRangeByType(dateRangeFilter.toJS());
    const dateRange = {
      startDate: {
        month: I18n.moment(dateRangeReport.startDate).format('MM'),
        year: I18n.moment(dateRangeReport.startDate).format('YYYY')
      },
      endDate: {
        month: I18n.moment(dateRangeReport.endDate).format('MM'),
        year: I18n.moment(dateRangeReport.endDate).format('YYYY')
      }
    };
    const metricNames = getReportMetricProperties(report).toArray().map(metric => metric === REPORT_OBJECT_ID_COUNT_PROPERTY ? HS_OBJECT_ID : metric);
    const customFilters = report.getIn(['config', 'filters', 'custom']);
    const pipelineFilter = customFilters ? customFilters.find(filter => filter.get('property') === 'pipeline') : undefined;
    const pipelineFilterValues = pipelineFilter ? pipelineFilter.get('values') : undefined;
    const pipelineIds = pipelineFilterValues ? pipelineFilterValues.toArray() : undefined;
    const ownerIdsList = getValueFromCustomFilters(customFilters, 'hubspot_owner_id', IN);
    const ownerIds = ownerIdsList ? ownerIdsList.toArray() : undefined;
    const teamIdsList = getValueFromCustomFilters(customFilters, 'hubspot_team_id', IN);
    const teamAssigneeIds = teamIdsList ? teamIdsList.toArray() : undefined;
    const fetchGoals = ungatedForAdditionalObjectTypes ? fetchDisaggregatedGoalsForReport({
      objectTypeId,
      frequency,
      dateRange,
      metricNames,
      pipelineIds,
      ownerIds,
      teamAssigneeIds
    }) : fetchGoalsForReport({
      objectTypeId,
      frequency,
      dateRange,
      metricNames,
      pipelineIds,
      ownerIds,
      teamAssigneeIds
    });
    fetchGoals.then(goalsForReport => {
      setLoading(false);
      setGoals(goalsForReport.reduce((accumulator, goal) => accumulator.set(getUniqueGoalForReportId(goal, ungatedForAdditionalObjectTypes), goal), ImmutableMap()));
    }).catch(err => {
      setLoading(false);
      setError(err);
    });
  }, [report, deferred, ungatedForAdditionalObjectTypes]);
  return {
    goals,
    loading,
    error
  };
};